// AddViewSupportContestComponent.jsx
import React, { useEffect, useMemo, useState } from "react";
import {
  Container,
  Row,
  Col,
  Label,
  Table,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Badge
} from "reactstrap";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import getYear from "date-fns/getYear";
import getMonth from "date-fns/getMonth";
import { BsPlusCircle } from "react-icons/bs";
import DatePicker, { registerLocale } from "react-datepicker";
import th from "date-fns/locale/th";
import { addYears } from "date-fns/esm/fp";
import { th as thBuddhist } from "date-fns/esm/locale";
import { format, parseISO } from "date-fns";

// ลงทะเบียน locale แบบพุทธศักราช
registerLocale("th-buddhist", {
  ...th,
  options: { ...th.options, weekStartsOn: 1 },
  formatLong: thBuddhist.formatLong,
});
// ---------------------- Helpers (ไทย พ.ศ.) ----------------------
const thaiMonths = [
  "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน",
  "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม",
];
const range = (start, end) => new Array(end - start).fill().map((_, i) => i + start);
const years = range(1963, new Date().getFullYear() + 8);

function formatMonthYearBE(date) {
  if (!date) return "";
  const be = addYears(543, date);
  console.log("be", be);
  console.log("format", format(be, "MMMM yyyy", { locale: th }))
  return format(be, "MMMM yyyy", { locale: th }); // เช่น “ธันวาคม 2568”
}

function fmtMoney(n) {
  const num = Number(n || 0);
  return num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
function toThaiDateLabel(iso) {
  if (!iso) return "-";
  const d = typeof iso === "string" ? parseISO(iso) : iso;
  const be = addYears(543, d);
  const monthName = format(be, "MMMM", { locale: th });
  return `${format(be, "dd")} ${monthName} ${format(be, "yyyy")}`;
}
function parseYearMonth(yyyymm) {
  const [y, m] = (yyyymm || "").split("-").map((v) => Number(v));
  return { y, m };
}
function sameMonth(iso, y, m) {
  const d = typeof iso === "string" ? parseISO(iso) : iso;
  return d.getFullYear() === y && (d.getMonth() + 1) === m;
}

// ===============================================================
//                     MAIN COMPONENT (ทั้งหน้า)
// ===============================================================
export function AddViewSupport49Component() {
  // ----- states เหมือนของเดิม -----
  const [reportMonth, setReportMonth] = useState(""); // "YYYY-MM"
  const [reportMonthDate, setReportMonthDate] = useState(null); // Date object
  const user = JSON.parse(localStorage.getItem("userData") || "{}");
  const deptId = user?.deptId || "";

  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]); // แถวในตารางของเดือนที่เลือก

  const [openModal, setOpenModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [isEditingReport, setIsEditingReport] = useState(false);

  // sync string <-> Date (เหมือนเดิม)
  useEffect(() => {
    if (!reportMonth) {
      setReportMonthDate(null);
      return;
    }
    const [y, m] = reportMonth.split("-").map(Number);
    setReportMonthDate(new Date(y, m - 1, 1));
  }, [reportMonth]);

  // รวมยอด footer
  const summary = useMemo(() => {
    const alloc = items.reduce((a, r) => a + Number(r.budgetAlloc || 0), 0);
    const actual = items.reduce((a, r) => a + Number(r.budgetActual || 0), 0);
    const remain = alloc - actual;
    return { alloc, actual, remain };
  }, [items]);

  // ----- ฟังก์ชันโหลดรอบรายงาน (เดือน/ปี) เหมือนแพทเทิร์นเดิม -----
  const checkAndLoadMonth = async () => {
    if (!reportMonth || !deptId) {
      Swal.fire("กรุณาเลือกรอบรายงาน (เดือน/ปี)", "", "warning");
      return;
    }
    try {
      setLoading(true);
      const q = new URLSearchParams({ monthYear: reportMonth, deptId });
      const res = await fetch(`/api/Support/viewContest?${q.toString()}`);
      const j = await res.json();

      if (j?.status !== 1) {
        throw new Error(j?.message || "ไม่สามารถโหลดข้อมูลได้");
      }

      // map ให้ตรงกับ state items ของตารางนี้
      const rows = (j?.dataenum || []).map((s, idx) => ({
        id: s.supportOperationContestId ?? idx + 1,
        deptId: s.deptId,
        detailContest: s.detailContest || "-",
        detailLevel: s.detailLevel || "-",
        detailBranch: s.detailBranch || "-",
        targetPerson: Number(s.targetPerson || 0),
        targetActual: Number(s.targetActual || 0),
        budgetAlloc: Number(s.budgetAlloc || 0),
        budgetActual: Number(s.budgetActual || 0),
        paymentDate: s.paymentDate, // "yyyy-MM-dd"
      }));

      setItems(rows);
      setIsEditingReport(rows.length > 0);   // ✅ ถ้ามีข้อมูล ถือว่าโหมดแก้ไข

    } catch (e) {
      console.error(e);
      Swal.fire("โหลดข้อมูลเดือนไม่สำเร็จ", e?.message || "", "error");
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  // modal helpers
  const openAdd = () => {
    setEditingItem(null);
    setOpenModal(true);
  };
  const openEdit = (row) => {
    setEditingItem(row);
    setOpenModal(true);
  };
  const closeModal = () => setOpenModal(false);

  return (
    <Container className="py-3">
      <Row className="g-3 align-items-end">
        <Col md={5}>
          <Label>รอบรายงาน (เดือน/ปี)</Label>
          <DatePicker
            selected={reportMonthDate}
            onChange={(date) => {
              if (date instanceof Date && !isNaN(date)) {
                const y = date.getFullYear();
                const m = String(date.getMonth() + 1).padStart(2, "0");
                setReportMonth(`${y}-${m}`);           // เก็บเป็น ค.ศ. ส่ง API
                setReportMonthDate(new Date(y, Number(m) - 1, 1)); // ใช้แสดงผล
              } else {
                setReportMonth("");
                setReportMonthDate(null);
              }
            }}
            dateFormat="MMMM yyyy"
            showMonthYearPicker
            showFullMonthYearPicker      // header ชัด ๆ ไม่มี grid เดือน
            locale="th-buddhist"
            placeholderText="เลือกเดือน/ปี (พ.ศ.)"
            value={formatMonthYearBE(reportMonthDate)}


            // ปรับ header ให้เรียบ สวย อ่านง่าย
            renderCustomHeader={({
              date,
              changeYear,
              changeMonth,
              decreaseMonth,
              increaseMonth,
              prevMonthButtonDisabled,
              nextMonthButtonDisabled,
            }) => (
              <div className="d-flex justify-content-between align-items-center px-2 py-1" style={{ gap: 8 }}>
                <button
                  type="button"
                  className="btn btn-sm btn-light"
                  onClick={decreaseMonth}
                  disabled={prevMonthButtonDisabled}
                  title="เดือนก่อนหน้า"
                >
                  ‹
                </button>

                <div className="d-flex align-items-center" style={{ gap: 8 }}>
                  <select
                    className="form-select form-select-sm"
                    style={{ width: 120 }}
                    value={thaiMonths[getMonth(date)]}
                    onChange={({ target: { value } }) => changeMonth(thaiMonths.indexOf(value))}
                  >
                    {thaiMonths.map((m) => (<option key={m} value={m}>{m}</option>))}
                  </select>

                  {/* ปีแสดง พ.ศ. แต่ value เก็บเป็น ค.ศ. */}
                  <select
                    className="form-select form-select-sm"
                    style={{ width: 100 }}
                    value={getYear(date)}
                    onChange={({ target: { value } }) => changeYear(Number(value))}
                  >
                    {years.map((y) => (
                      <option key={y} value={y}>{y + 543}</option>
                    ))}
                  </select>
                </div>

                <button
                  type="button"
                  className="btn btn-sm btn-light"
                  onClick={increaseMonth}
                  disabled={nextMonthButtonDisabled}
                  title="เดือนถัดไป"
                >
                  ›
                </button>
              </div>
            )}
            // ใช้ customInput เพื่อ "โชว์ พ.ศ." ในช่องอินพุต
            customInput={
              <input
                className="form-control rounded-pill text-center input-color"
                readOnly
                value={formatMonthYearBE(reportMonthDate)}
                placeholder="เลือกเดือน/ปี (พ.ศ.)"
              />
            }
          />
        </Col>

        <Col md="auto" className="pt-4">
          <button className="btn btn-primary" onClick={checkAndLoadMonth} disabled={!reportMonth}>
            ตรวจสอบ/โหลดรายงาน
          </button>
        </Col>
        {/* ✅ ปุ่มเพิ่มรายการ (เพิ่มมาให้แล้ว) */}
        <Col md="auto" className="pt-4">
          <button className="btn btn-success" onClick={openAdd} disabled={!reportMonth}>
            {/* เอาไอคอนออกได้ถ้าไม่ต้องการ */}
            <BsPlusCircle className="me-1" />
            เพิ่มรายการ
          </button>
        </Col>

        <Col md="auto" className="pt-4">
          {reportMonth && (
            <Badge color={isEditingReport ? "warning" : "success"} pill className="px-3 py-2">
              {isEditingReport ? "โหมดแก้ไขรายงาน" : "โหมดสร้างรายงานใหม่"}
            </Badge>
          )}
        </Col>
      </Row>

      {/* ----------------- ตารางแบบในภาพ ----------------- */}
      <div className="mt-3">
        <Table bordered responsive>
          <thead className="table-light">
            <tr>
              <th rowSpan="2" className="text-center align-middle">
                ที่
              </th>
              <th rowSpan="2" className="text-center align-middle">
                รายละเอียดค่าใช้จ่ายในการแข่งขันฝีมือแรงงาน
              </th>
              <th rowSpan="2" className="text-center align-middle">
                ระดับ
              </th>
              <th rowSpan="2" className="text-center align-middle">
                สาขา
              </th>
              <th colSpan="2" className="text-center align-middle">
                จำนวนคนผู้เข้าแข่งขัน
              </th>
              <th colSpan="2" className="text-center align-middle">
                จำนวนเงินค่าใช้จ่าย
              </th>
              <th rowSpan="2" className="text-center align-middle">
                คงเหลือ<br />(บาท)
              </th>
              <th rowSpan="2" className="text-center align-middle">
                วันที่จ่ายเงินช่วยเหลือหรืออุดหนุน
              </th>
              <th rowSpan="2" className="text-center align-middle">
                จัดการ
              </th>
            </tr>
            <tr>
              <th className="text-center align-middle">
                กลุ่มเป้าหมาย<br />(คน)
              </th>
              <th className="text-center align-middle">
                ผู้เข้าร่วมงานแข่งขันจริง<br />(คน)
              </th>
              <th className="text-center align-middle">
                งบประมาณที่ได้รับจัดสรร<br />(บาท)
              </th>
              <th className="text-center align-middle">
                งบประมาณที่ใช้จริง<br />(บาท)
              </th>
            </tr>
          </thead>

          <tbody>
            {items.length === 0 && (
              <tr>
                <td colSpan={11} className="text-center">
                  ยังไม่มีรายการ
                </td>
              </tr>
            )}

            {items.map((r, idx) => {
              const remain =
                Number(r.budgetAlloc || 0) - Number(r.budgetActual || 0);
              return (
                <tr key={r.id || idx}>
                  <td className="text-center">{idx + 1}</td>
                  <td>{r.detailContest || "-"}</td>
                  <td className="text-center">{r.detailLevel || "-"}</td>
                  <td className="text-center">{r.detailBranch || "-"}</td>
                  <td className="text-center">
                    {Number(r.targetPerson || 0).toLocaleString()}
                  </td>
                  <td className="text-center">
                    {Number(r.targetActual || 0).toLocaleString()}
                  </td>
                  <td className="text-center">{fmtMoney(r.budgetAlloc)}</td>
                  <td className="text-center">{fmtMoney(r.budgetActual)}</td>
                  <td className="text-center">{fmtMoney(remain)}</td>
                  <td className="text-center">
                    {toThaiDateLabel(r.paymentDate)}
                  </td>
                  <td className="text-center">
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={() => openEdit(r)}
                    >
                      แก้ไข
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>

          {items.length > 0 && (
            <tfoot>
              <tr>
                <td colSpan={6} className="text-end fw-bold">
                  รวม
                </td>
                <td className="text-center fw-bold">
                  {fmtMoney(summary.alloc)}
                </td>
                <td className="text-center fw-bold">
                  {fmtMoney(summary.actual)}
                </td>
                <td className="text-center fw-bold">
                  {fmtMoney(summary.remain)}
                </td>
                <td colSpan={2}></td>
              </tr>
            </tfoot>
          )}
        </Table>
      </div>

      {/* ----------------- Modal เพิ่ม/แก้ไข ----------------- */}
      <Modal
        isOpen={openModal}
        toggle={closeModal}
        centered
        size="lg"
        backdrop="static"
      >
        <ModalHeader toggle={closeModal}>
          {editingItem ? "แก้ไขรายการ" : "เพิ่มรายการ"}
        </ModalHeader>
        <ModalBody>
          <ContestForm
            deptId={deptId}
            reportMonth={reportMonth}
            editingItem={editingItem}
            onSaved={(saved) => {
              // อัปเดตตารางแบบง่าย ๆ
              if (editingItem) {
                setItems((prev) =>
                  prev.map((x) =>
                    String(x.id) === String(saved.id) ? saved : x
                  )
                );
              } else {
                setItems((prev) => [...prev, saved]);
              }
              closeModal();
            }}
          />
        </ModalBody>
      </Modal>

      {loading && (
        <div className="position-fixed bottom-0 end-0 p-3">
          <span className="badge bg-secondary">กำลังโหลด...</span>
        </div>
      )}
    </Container>
  );
}

// ===============================================================
//                         FORM COMPONENT
// ===============================================================
function ContestForm({ deptId, reportMonth, editingItem, onSaved }) {
  const schema = Yup.object().shape({
    detailContest: Yup.string().required("กรอกข้อมูล"),
    detailLevel: Yup.string().required("กรอกข้อมูล"),
    detailBranch: Yup.string().required("กรอกข้อมูล"),
    targetPerson: Yup.number().typeError("ตัวเลข").min(0).required("กรอก"),
    targetActual: Yup.number().typeError("ตัวเลข").min(0).required("กรอก"),
    budgetAlloc: Yup.number().typeError("ตัวเลข").min(0).required("กรอก"),
    budgetActual: Yup.number().typeError("ตัวเลข").min(0).required("กรอก"),
    paymentDate: Yup.string().required("เลือกวันที่จ่าย"),
  });

  const init = {
    id: editingItem?.id ?? editingItem?.supportOperationContestId ?? null,
    deptId,
    detailContest: editingItem?.detailContest ?? "",
    detailLevel: editingItem?.detailLevel ?? "",
    detailBranch: editingItem?.detailBranch ?? "",
    targetPerson: editingItem?.targetPerson ?? 0,
    targetActual: editingItem?.targetActual ?? 0,
    budgetAlloc: editingItem?.budgetAlloc ?? 0,
    budgetActual: editingItem?.budgetActual ?? 0,
    paymentDate: editingItem?.paymentDate ?? "", // "yyyy-MM-dd"
  };

  const { y, m } = parseYearMonth(reportMonth || "2000-01");

  return (
    <Formik
      initialValues={init}
      validationSchema={schema}
      onSubmit={async (v, act) => {
        try {
          if (!sameMonth(v.paymentDate, y, m)) {
            Swal.fire("วันที่จ่ายต้องอยู่ในเดือนที่เลือก", "", "error");
            return;
          }

          const payload = {
            supportOperationContestId: v.id, // มีค่าเมื่อแก้ไข
            deptId: v.deptId,
            detailContest: v.detailContest,
            detailLevel: v.detailLevel,
            detailBranch: v.detailBranch,
            targetPerson: Number(v.targetPerson || 0),
            targetActual: Number(v.targetActual || 0),
            budgetAlloc: Number(v.budgetAlloc || 0),
            budgetActual: Number(v.budgetActual || 0),
            paymentDate: v.paymentDate, // yyyy-MM-dd
          };

          const res = await fetch("/api/Support/saveContest", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          });
          const j = await res.json();

          if (j?.status === 1) {
            const savedRow = {
              ...v,
              id: v.id || j.id, // รองรับกรณีเพิ่มใหม่
            };
            Swal.fire("บันทึกสำเร็จ", "", "success");
            onSaved && onSaved(savedRow);
          } else {
            Swal.fire("บันทึกไม่สำเร็จ", j?.message || "", "warning");
          }
        } catch (e) {
          Swal.fire("บันทึกไม่สำเร็จ", e?.message || "", "error");
        } finally {
          act.setSubmitting(false);
        }
      }}
    >
      {({ values, setFieldValue, touched, errors }) => {
        const selectedDate = values.paymentDate
          ? new Date(values.paymentDate)
          : null;

        return (
          <Form>
            <Row className="g-3">
              <Col md={12}>
                <Label>รายละเอียดค่าใช้จ่ายในการแข่งขันฝีมือแรงงาน</Label>
                <Field name="detailContest">
                  {({ field }) => (
                    <Input
                      {...field}
                      className={`rounded-pill ${touched.detailContest && errors.detailContest
                        ? "is-invalid"
                        : ""
                        }`}
                    />
                  )}
                </Field>
                {touched.detailContest && errors.detailContest && (
                  <div className="invalid-feedback d-block">
                    {errors.detailContest}
                  </div>
                )}
              </Col>

              <Col md={4}>
                <Label>ระดับ</Label>
                <Field name="detailLevel">
                  {({ field }) => (
                    <Input
                      {...field}
                      className={`rounded-pill ${touched.detailLevel && errors.detailLevel
                        ? "is-invalid"
                        : ""
                        }`}
                    />
                  )}
                </Field>
                {touched.detailLevel && errors.detailLevel && (
                  <div className="invalid-feedback d-block">
                    {errors.detailLevel}
                  </div>
                )}
              </Col>

              <Col md={8}>
                <Label>สาขา</Label>
                <Field name="detailBranch">
                  {({ field }) => (
                    <Input
                      {...field}
                      className={`rounded-pill ${touched.detailBranch && errors.detailBranch
                        ? "is-invalid"
                        : ""
                        }`}
                    />
                  )}
                </Field>
                {touched.detailBranch && errors.detailBranch && (
                  <div className="invalid-feedback d-block">
                    {errors.detailBranch}
                  </div>
                )}
              </Col>

              <Col md={6}>
                <Label>กลุ่มเป้าหมาย (คน)</Label>
                <Field name="targetPerson">
                  {({ field }) => (
                    <Input
                      type="number"
                      min="0"
                      {...field}
                      className={`rounded-pill text-center ${touched.targetPerson && errors.targetPerson
                        ? "is-invalid"
                        : ""
                        }`}
                    />
                  )}
                </Field>
                {touched.targetPerson && errors.targetPerson && (
                  <div className="invalid-feedback d-block">
                    {errors.targetPerson}
                  </div>
                )}
              </Col>

              <Col md={6}>
                <Label>ผู้เข้าร่วมงานแข่งขันจริง (คน)</Label>
                <Field name="targetActual">
                  {({ field }) => (
                    <Input
                      type="number"
                      min="0"
                      {...field}
                      className={`rounded-pill text-center ${touched.targetActual && errors.targetActual
                        ? "is-invalid"
                        : ""
                        }`}
                    />
                  )}
                </Field>
                {touched.targetActual && errors.targetActual && (
                  <div className="invalid-feedback d-block">
                    {errors.targetActual}
                  </div>
                )}
              </Col>

              <Col md={6}>
                <Label>งบประมาณที่ได้รับจัดสรร (บาท)</Label>
                <Field name="budgetAlloc">
                  {({ field }) => (
                    <Input
                      type="number"
                      min="0"
                      step="0.01"
                      {...field}
                      className={`rounded-pill text-center ${touched.budgetAlloc && errors.budgetAlloc
                        ? "is-invalid"
                        : ""
                        }`}
                    />
                  )}
                </Field>
                {touched.budgetAlloc && errors.budgetAlloc && (
                  <div className="invalid-feedback d-block">
                    {errors.budgetAlloc}
                  </div>
                )}
              </Col>

              <Col md={6}>
                <Label>งบประมาณที่ใช้จริง (บาท)</Label>
                <Field name="budgetActual">
                  {({ field }) => (
                    <Input
                      type="number"
                      min="0"
                      step="0.01"
                      {...field}
                      className={`rounded-pill text-center ${touched.budgetActual && errors.budgetActual
                        ? "is-invalid"
                        : ""
                        }`}
                    />
                  )}
                </Field>
                {touched.budgetActual && errors.budgetActual && (
                  <div className="invalid-feedback d-block">
                    {errors.budgetActual}
                  </div>
                )}
              </Col>

              <Col md={6}>
                <Label>วันที่จ่ายเงินช่วยเหลือ/อุดหนุน</Label>
                <DatePicker
                  selected={selectedDate}
                  locale="th-buddhist"                 // ✅ ปฏิทินภาษาไทย + พ.ศ.
                  calendarClassName="thai-buddhist"   // (ออปชัน: ไว้ใส่ css เพิ่มได้)
                  dateFormat="dd MMMM yyyy"           // ✅ รูปแบบไทย
                  placeholderText="กรุณาเลือก"
                  // header แบบไทย: เดือนภาษาไทย + ปี พ.ศ.
                  renderCustomHeader={({
                    date,
                    changeYear,
                    changeMonth,
                    decreaseMonth,
                    increaseMonth,
                    prevMonthButtonDisabled,
                    nextMonthButtonDisabled,
                  }) => (
                    <div className="d-flex justify-content-between align-items-center px-2 py-1" style={{ gap: 8 }}>
                      <button
                        type="button"
                        className="btn btn-sm btn-light"
                        onClick={decreaseMonth}
                        disabled={prevMonthButtonDisabled}
                        aria-label="previous month"
                      >
                        ‹
                      </button>

                      <div className="d-flex align-items-center" style={{ gap: 8 }}>
                        {/* เดือนภาษาไทย */}
                        <select
                          className="form-select form-select-sm"
                          style={{ width: 140 }}
                          value={thaiMonths[(selectedDate || date).getMonth()]}
                          onChange={({ target: { value } }) => changeMonth(thaiMonths.indexOf(value))}
                        >
                          {thaiMonths.map((m) => (
                            <option key={m} value={m}>{m}</option>
                          ))}
                        </select>

                        {/* ปี: แสดง พ.ศ. แต่ค่าเป็น ค.ศ. */}
                        <select
                          className="form-select form-select-sm"
                          style={{ width: 110 }}
                          value={(selectedDate || date).getFullYear()}
                          onChange={({ target: { value } }) => changeYear(Number(value))}
                        >
                          {years.map((y) => (
                            <option key={y} value={y}>{y + 543}</option>
                          ))}
                        </select>
                      </div>

                      <button
                        type="button"
                        className="btn btn-sm btn-light"
                        onClick={increaseMonth}
                        disabled={nextMonthButtonDisabled}
                        aria-label="next month"
                      >
                        ›
                      </button>
                    </div>
                  )}
                  onChange={(date) => {
                    if (date instanceof Date && !isNaN(date)) {
                      const y2 = date.getFullYear();
                      const m2 = String(date.getMonth() + 1).padStart(2, "0");
                      const d2 = String(date.getDate()).padStart(2, "0");
                      const iso = `${y2}-${m2}-${d2}`;
                      // ✅ บังคับให้ตรงเดือนที่เลือก (เหมือนเดิม)
                      if (!sameMonth(iso, y, m)) {
                        Swal.fire("วันที่จ่ายต้องอยู่ในเดือนที่เลือก", "", "error");
                        return;
                      }
                      setFieldValue("paymentDate", iso);
                    } else {
                      setFieldValue("paymentDate", "");
                    }
                  }}
                  // ✅ ช่องอินพุตแสดงเป็น “วัน เดือนไทย ปีพ.ศ.”
                  customInput={
                    <Input
                      type="text"
                      value={values.paymentDate ? toThaiDateLabel(values.paymentDate) : ""}
                      readOnly
                      className={`rounded-pill text-center ${touched.paymentDate && errors.paymentDate ? "is-invalid" : ""}`}
                    />
                  }
                />

                {touched.paymentDate && errors.paymentDate && (
                  <div className="invalid-feedback d-block">
                    {errors.paymentDate}
                  </div>
                )}
              </Col>

              <div className="d-flex justify-content-between mt-3">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() => window.history.back?.()}
                >
                  ยกเลิก
                </button>
                <button type="submit" className="btn btn-success">
                  {editingItem ? "บันทึกการแก้ไข" : "บันทึกรายการ"}
                </button>
              </div>
            </Row>
          </Form>
        );
      }}
    </Formik>
  );
}
